import {isNil} from 'ramda';

import {RentalPriceGroupItemResponseBody, RentalPriceGroupResponseBody} from '@dms/api/vehicle';
import i18n from '@dms/i18n';

import {Nullish} from 'shared/web';

export const getPricingTitle = (
  activePriceGroupItem: RentalPriceGroupItemResponseBody | Nullish,
  priceGroupData: RentalPriceGroupResponseBody | Nullish
) => {
  if (isNil(activePriceGroupItem)) {
    return i18n.t('entity.rental.labels.noPriceGroup');
  }

  const period =
    activePriceGroupItem?.range.period === 'day'
      ? i18n.t('entity.financing.labels.days')
      : i18n.t('general.metric.months');
  const priceGroupRange = `(${activePriceGroupItem?.range?.from}-${activePriceGroupItem?.range?.to} ${period})`;
  const priceGroupName = `${i18n.t('entity.rental.labels.priceGroup')}: ${priceGroupData?.name} ${priceGroupRange}`;

  return priceGroupName;
};
